module.exports = __webpack_public_path__ + "static/img/roda.da7be75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/roda.png
// module id = D//k
// module chunks = 3